import { ActionType, NEW_ERROR, CLEAR_ALL} from '../actions/errorInfo'
import { Error } from '../types/Errors/Error';

export interface ErrorInfoState {
    lastError?: Error
}

const initialState: ErrorInfoState = {
    lastError: undefined
}

export function errorInfoReducer(state: ErrorInfoState = initialState, action: ActionType) {
    switch (action.type) {
        case CLEAR_ALL: {
            return {
                lastError: undefined
            }
        }
        case NEW_ERROR: {
            return {
                ...state,
                lastError: action.payload.error
            }
        }
        default: return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/ErrorInfo.ts